export enum SurveyOption {
	EDIT,
	DUPLICATE,
	CREATE
}
